export default {
  label: {
    series: {
      receivedMessages: 'Mensajes recebidas',
      sentMessages: 'Mensajes enviadas',
    },
  },
};
